import {persistPhotoSessionGroupContactId, readPhotoSessionGroupContactId} from "./photo-session-group-contact-id-storage"
import {atom} from "recoil"

export const currentPhotoSessionGroupContactIdAtom = atom({
  default: readPhotoSessionGroupContactId(localStorage),
  key: "currentPhotoSessionGroupContactIdAtom",
  effects: [
    ({onSet}) => {
      onSet((value) => {
        persistPhotoSessionGroupContactId(localStorage, value)
      })
    }
  ]
})
